var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScale2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 496.2,
    width: 16,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,496.2V135.3H361v89.9h15v-74.9h75v345.8h-75v-256h-15v256h-52.6V270.3h-105v225.9H151v-75.4h-15v75.4h-75V345.3h75 v59.9h15v-74.9h-105v165.9H31v15h481v-15H466z M218.5,285.3h75v210.9h-75V285.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.7,27.7l8.1,48.7l14.8-2.5l-12.2-73l-73,12.2l2.5,14.8l46.9-7.9c-41.8,61.1-93.2,113.8-153,156.9 c-72.9,52.5-157.7,89.4-245.2,106.8l2.9,14.7c89.6-17.8,176.4-55.6,251.1-109.3C330,144.7,382.8,90.5,425.7,27.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 360.2,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.5,
    y: 300.2,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.3,
    y: 165.2,
    width: 15,
    height: 15
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScale2);
export default __webpack_public_path__ + "static/media/icon-scale2.7f5377c12d65034b61fac210432ac9f6.svg";
export { ForwardRef as ReactComponent };